import { render, staticRenderFns } from "./SwayWallOfLove.vue?vue&type=template&id=28451ce6&scoped=true&"
import script from "./SwayWallOfLove.vue?vue&type=script&lang=js&"
export * from "./SwayWallOfLove.vue?vue&type=script&lang=js&"
import style0 from "./SwayWallOfLove.vue?vue&type=style&index=0&id=28451ce6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28451ce6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VExpansionPanels,VRow})
